import React from 'react';
import axios from "axios";

export default class PSMPSummit extends React.Component {
    state = {
        Mess : ""
    }
    onChange =(e)=>{
        if(e.key === 'Enter'){
            // this.OnSent(e.target.value);
            this.nameInput1.value = "";
        }
    }
    onClickSave = (e)=>{
        // this.OnSent(this.nameInput1.value);
        this.nameInput1.value = "";
        console.log(this.nameInput2.value)
    }

    OnSent = (code)=>{
        var url = "https://psmpapi.pspl.co.th/TFProduct/Test?api_key=1zMtvnYpkYYzFOIkpcg9p7OXBM0zXS3ZFzA8Urqd&code="+code+"&date=25610807"
        console.log(url);
        axios.get(url).then(res =>{
            if(res.data ==="0"){
                console.log(code)
                
            }
            this.setState({Mess:res.data})
        }).catch(err=>{
            console.log("err")
        });
    }

    componentDidMount(){
    };
  render() {  
    return (
        <div class="container" align="center">
        <div align="center">
                <nav class="navbar navbar-dark bg-primary">
                    <div class="flex-list">
                        <ul class="nav navbar-nav navbar-right" style={{'margin-right':'0px'}}>
                            <li>ยอดยกมา</li>
                            <span className="pipe"></span>
                        </ul>
                    </div>
                </nav>   
            </div>
            <div class="input-group group-custom" style={{height:"40px"}}>
                <span class="input-group-addon texttxt"> รหัสสินค้า : </span>
                <input type="text" class="form-control input-custom" onKeyPress={this.onChange} ref={(input) => { this.nameInput1 = input; }} style={{height:"40px"}}/>
                <span class="input-group-addon textIcon" onClick={this.onClickSave} > <i class="far fa-save"></i> </span>  
                
                <input type="date" class="form-control input-custom" ref={(input) => { this.nameInput2 = input; }} style={{height:"40px",maxWidth:"135px"}}/>

            </div>
            <div class="input-group group-custom">{this.state.Mess}</div>
        </div>
    )
  }
}